import { type LotteryTicketType } from '../types/lottery';

interface ParseLotteryTicketReturnType {
  type?: LotteryTicketType;
  lotteryNumber?: string;
  source?: string;
  suffix?: string;
}

const parseLotteryTicket = (ticket: string): ParseLotteryTicketReturnType => {
  const tierSign = ticket[0];
  const lotteryNumber = ticket.match(/^.(\d+)[A-Za-z]+/)?.[1];
  const source = ticket.match(/([A-Za-z]{2})\d{5}$/)?.[1];
  const suffix = ticket.match(/(\d{5})$/)?.[1];

  const tierSignDictionary: Record<string, LotteryTicketType> = {
    S: 'Silver',
    G: 'Gold',
    D: 'Diamond',
  };

  const type =
    tierSign && tierSign in tierSignDictionary
      ? tierSignDictionary[tierSign]
      : undefined;

  return {
    type,
    lotteryNumber,
    source,
    suffix,
  };
};

export { parseLotteryTicket };
